import React, { useEffect, useState } from "react";

// ASSETS
import ArrowLeft from "assets/svg/ArrowDown.svg";
import { ReactComponent as NoDataDark } from "assets/svg/NoDataDark.svg";

// STYLES
import {
  ActivityReportsContainer,
  ActivityReportsContentCardContainer,
  ActivityReportsContentCardTextWrapper,
  ActivityReportsContentCardTitleWrapper,
  ActivityReportsIcon,
  ActivityReportsIconWrapper,
  ActivityReportsReportCardsContainer,
  ActivityReportsRightSideContent,
  BackToGuidesButton,
  BackToGuidesImage,
  BackToWrapper,
  LeftSideContainer,
  RightSideContainer,
  TitleSectionWrapper,
  TitleWrapper,
  ReportsSectionReportCardWrapper,
  ReportsSectionReportCardTitleWrapper,
  ReportsSectionReportCardIconWrapper,
  ReportsSectionReportCardIcon,
  NoDataContainer,
  SvgContainer,
} from "./ActivityReportsStyled";

// LIBRARIES
import usePagination from "hooks/usePagination";
import { useTranslation } from "react-i18next";

// MISC
import { IProps } from "./ActivityReportsModel";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import aboutService from "services/aboutService";

// REDUX
import { useSelector } from "react-redux";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";

// COMPONENTS
import Pagination from "components/Atoms/Paginations/Pagination";
import CustomText from "components/Atoms/CustomText/CustomText";
import useWindowWidth from "hooks/useWindowWidth";

const ActivityReports = (props: IProps) => {
  // PROPERTIES
  

  // LIBRARY CONSTANTS
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);
  const { t } = useTranslation();
  const width = useWindowWidth();

  // STATE CONSTANTS
  const [reports, setReports] = useState<any>(null);
  let ELEMENTS_PER_PAGE;
  if (width < 600) {
    ELEMENTS_PER_PAGE = 6; 
  } else if (width < 1024) {
    ELEMENTS_PER_PAGE = 8;
  } else {
    ELEMENTS_PER_PAGE = 15; 
  }

  // API REQUESTS

  // LIFE CYCLE
  useEffect(() => {
    aboutService
      .getActivityReports()
      .then((response) => {
        setReports(response);
      })
      .catch((err) => {
        console.log("getReports error", err);
      });
  }, []);

  // Sort and slice reports
  const sortedReports = reports?.data
    ?.sort(
      (a, b) =>
        new Date(b.attributes.createdAt).getTime() -
        new Date(a.attributes.createdAt).getTime()
    )
    ?.slice(0, 6);

  const {
    currentPage: currentReportsPage,
    totalPages: reportsPages,
    currentData: currentReports,
    handlePageChange: handleReportsPageChange,
  } = usePagination(reports?.data || [], ELEMENTS_PER_PAGE);

  const reportsList = (
    <ActivityReportsReportCardsContainer>
      {currentReports.map((report, index) => (
        <ReportsSectionReportCardWrapper
          key={index}
          href={`${process.env.REACT_APP_UPLOAD_URL}${report?.attributes?.documents?.data[0]?.attributes?.attached_document?.data?.attributes?.url}`}
          target={"_blank"}
        >
          <ReportsSectionReportCardTitleWrapper>
            <CustomText
              text={`Raport ${report?.attributes?.year}`}
              type={TextType.H4}
              color={COLORS.RaisinBlack}
            />
          </ReportsSectionReportCardTitleWrapper>
          <ReportsSectionReportCardIconWrapper>
            <ReportsSectionReportCardIcon />
          </ReportsSectionReportCardIconWrapper>
        </ReportsSectionReportCardWrapper>
      ))}
    </ActivityReportsReportCardsContainer>
  );

  // EVENT HANDLERS

  return (
    <ActivityReportsContainer>
      <LeftSideContainer>
        <TitleSectionWrapper>
          <BackToWrapper
            onClick={() => window.history.back()}
            biggerCursor={biggerCursor}
          >
            <BackToGuidesImage src={ArrowLeft} alt="backIcon" />
            <BackToGuidesButton>
              <CustomText
                text={t("view.about.aboutDSU.button")}
                type={TextType.H5bold}
                color={COLORS.MetalicSilver}
              />
            </BackToGuidesButton>
          </BackToWrapper>
          <TitleWrapper>
            <CustomText
              type={TextType.H2}
              text={t("view.reports.title")}
              color={COLORS.RaisinBlack}
            />
          </TitleWrapper>
        </TitleSectionWrapper>
        <ActivityReportsRightSideContent>
          <ActivityReportsIconWrapper>
            <ActivityReportsIcon />
          </ActivityReportsIconWrapper>
          <ActivityReportsContentCardContainer>
            <ActivityReportsContentCardTitleWrapper>
              <CustomText
                text={t("view.reports.title")}
                type={TextType.H2}
                color={COLORS.Yellow}
              />
            </ActivityReportsContentCardTitleWrapper>
            <ActivityReportsContentCardTextWrapper>
              <CustomText
                text={t("view.about.aboutDSU.reportsSection.text")}
                type={TextType.P1}
                color={COLORS.Cultured}
              />
            </ActivityReportsContentCardTextWrapper>
          </ActivityReportsContentCardContainer>
        </ActivityReportsRightSideContent>
      </LeftSideContainer>
      <RightSideContainer>
        {reports != null ? (
          reportsList
        ) : (
          <NoDataContainer>
            <SvgContainer>
              <NoDataDark />
            </SvgContainer>
            <CustomText
              text={t("app.noData")}
              type={TextType.H4}
              color={COLORS.MetalicSilver}
            />
          </NoDataContainer>
        )}
        {reportsPages > 1 && (
          <Pagination
            totalPages={reportsPages}
            currentPage={currentReportsPage}
            onPageChange={handleReportsPageChange}
          />
        )}
      </RightSideContainer>
    </ActivityReportsContainer>
  );
};

export default ActivityReports;
